<script setup lang="ts">
import type { Player } from '@acepoker/contract'
import CodeInput from './shared/forms/CodeInput.vue'
import Modal from './shared/Modal.vue'
import ExitAssessmentForm from './shared/forms/ExitAssessmentForm.vue'
import { useLoginWithCode } from '@/composables/useLoginWithCode'
import { useMultiStepFormNavigation } from '@/composables/useMultiStepFormNavigation'
import { useRouter } from 'vue-router'
import { toRef } from 'vue'

const router = useRouter()

const props = defineProps<{
  isOpen: boolean
  onSuccess: (player: Player) => void
  onError?: (error: string) => void
  onClose?: () => void
  hideCloseButton?: boolean
  onKeepPracticing?: () => void
  onContinueWithoutSaving?: () => void
}>()

const {
  isCodeSent,
  countdown,
  email,
  pinError,
  errors,
  handleComplete,
  onSendCode,
  close: closeLogin
} = useLoginWithCode(
  (player) => {
    props.onSuccess(player)
  },
  (error) => {
    if (props.onError) props.onError(error)
  }
)

useMultiStepFormNavigation(isCodeSent, false, toRef(props, 'isOpen'))

const close = () => {
  closeLogin()
  props?.onClose?.()
}

const continueWithoutSaving = () => {
  closeLogin()
  if (props.onContinueWithoutSaving) {
    props.onContinueWithoutSaving()
  } else {
    router.push({ name: 'home2' })
    props?.onClose?.()
  }
}
</script>

<template>
  <Modal :isOpen="isOpen" :hideCloseButton="hideCloseButton" :onClose="close" :isBlurred="true">
    <div v-if="!isCodeSent">
      <ExitAssessmentForm
        :email="email"
        :onSendCode="onSendCode"
        :onEmailChange="(newEmail) => (email = newEmail)"
        :onKeepPracticing="props.onKeepPracticing || close"
        :onContinueWithoutSaving="continueWithoutSaving"
        :isCodeSent="isCodeSent"
        :countdown="countdown"
        :errors="errors"
      />
    </div>
    <div v-else>
      <CodeInput
        :error="pinError"
        :countdown="countdown"
        :onResendCode="onSendCode"
        :email="email"
        @complete="handleComplete"
      />
    </div>
  </Modal>
</template>
